export default __webpack_public_path__ + "static/media/255.f8465be3.jpg";